import { InputProps } from "types/html";
import classNames from "classnames";
import { forwardRef, LegacyRef } from "react";

import { AppSelect, AppSelectProps } from "components/Select/Select";

type NamedInputProps = InputProps &
  AppSelectProps & {
    name?: string;
    nameClassName?: string;
    placeholder?: string;
    isDisabled?: string;
    className?: string;
    containerClassName?: string;
    isMulti?: boolean;
  };

export const NamedSelect = forwardRef(
  (props: NamedInputProps, ref: LegacyRef<any>): JSX.Element => {
    const {
      name,
      className,
      nameClassName,
      placeholder,
      containerClassName = "",
      ...rest
    } = props;

    return (
      <div
        className={classNames("flex items-center", containerClassName)}
        ref={ref}
      >
        {name && (
          <p style={{ fontSize: "12px" }} className={nameClassName}>
            {name}:
          </p>
        )}
        <AppSelect
          {...rest}
          placeholder={placeholder || ""}
          className={className || ""}
        />
      </div>
    );
  }
);
